import {useEffect, useState} from "react";
import {baronCategories, baronBranches} from "../../data/restaurantSpecific"
import MainTemplateOne from "./MainTemplateForm"

function BaronForm({formData, setFormData, restaurantName, activeDashboard}) {

    const [categoryList, setCategoryList] = useState([]);
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {

        //console.log("the form data is: ", formData)
        
        //figure out how to deal with branches

        setCategoryList(baronCategories)
        setBranches(baronBranches); //CHANGE THIS AND MAKE branches part of the model
        setLoading(false);

       
    })

    if(!loading) {
        return (
            <MainTemplateOne 
                formData = {formData} 
                setFormData = {setFormData} 
                restaurantName= {restaurantName} 
                categoryList = {categoryList}
                activeDashboard = {activeDashboard}
                branches = {branches}
            />
        )
    }
}

export default BaronForm;